import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bix-loader',
  templateUrl: './bix-loader.component.html',
  styleUrls: ['./bix-loader.component.scss']
})
export class BixLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
